import * as yup from 'yup';
import { FORM_MESSAGE } from '../../fastForm/data/constants';

export const balanceTransferSchema = (detailsRequired: boolean) =>
	yup.object().shape({
		balanceTransfer: yup.object().shape({
			amount: yup
				.number()
				.required(FORM_MESSAGE.required)
				.test('number', FORM_MESSAGE.number, (value) => {
					if (value === undefined || value === null) {
						return true;
					}
					return !isNaN(Number(value));
				})
				.test('isPositive', FORM_MESSAGE.postiveNum, (value) => {
					return value > 0;
				}),
			policyholderTo: yup.string().required(FORM_MESSAGE.required),
			policyTo: yup
				.string()
				.required(FORM_MESSAGE.required)
				.test('string', FORM_MESSAGE.required, (value) => {
					if (value === undefined || value === null || value === '') {
						return false;
					}
					return true;
				}),
			name: yup.string().required(FORM_MESSAGE.required),
			details: detailsRequired
				? yup.string().required(FORM_MESSAGE.required)
				: yup.string(),
		}),
	});
